import React from "react";
import { lazyRetry } from "../../helpers";

export default React.lazy(() =>
  lazyRetry(() => import("./index"), "insights-page")
);
